import React from "react";

import Breadcrumbs from "../../../../../components/Breadcrumbs";
import AptitudeResultTable from "./AptitudeResultTable";

import { useTranslation } from "react-i18next";

const AptitudeResults = () => {

  const { t } = useTranslation();

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle={t('Aptitude Result')}
            title="Dashboard"
            subtitle={t('Jobs')+' / '+t('Aptitude Result')}
          />
          <AptitudeResultTable />
        </div>
      </div>
    </>
  );
};

export default AptitudeResults;
